import styled, { css } from 'styled-components';
import { Text } from '../../atoms';

export const Wrapper = styled.div`
  margin-bottom: 40px;
  min-width: 676px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DropZone = styled.div<{ $isActive?: boolean }>`
  width: 100%;
  min-height: 386px;
  border: 1px dashed ${({ theme }) => theme.colors.grey50};
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${({ $isActive, theme }) =>
    $isActive &&
    css`
      border-color: ${theme.colors.yellow60};
      background-color: ${theme.colors.yellow10};
    `}

  & > .ant-row {
    height: 100%;
  }
`;

export const StatusColumnWrapper = styled.div`
  min-width: 142px;
  display: flex;
  justify-content: center;
`;

export const Icon = styled.img``;

export const TextLink = styled(Text)`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.grey50};
`;

export const PreviewWrapper = styled.div``;
